import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-not-authorized',
    standalone: true,
    imports: [RouterModule, ButtonModule],
    templateUrl: 'not-authorized.component.html'
})
export class NotAuthorizedComponent {
    mainDashboard: string = environment.mainDashboard;
    logoPath: string = environment.logo;
    companyName: string = environment.companyName;
}
